/**
 * js加载器，
 * 需要加入localStroage
 * **/
import { urlToObj, objectParseToString } from "./urlObj";
var LoaderCache = {};
//缓存管理器
function cacheUrl(url) {
    var _url = url;
    if (url.indexOf("?") != -1) {//根据url判断是否需要缓存，一个值为key一个值为ver版本好
        let urlParams = urlToObj(url);
        if (urlParams.hasOwnProperty("key")) {
            if (!urlParams.hasOwnProperty("ver")) {
                urlParams.ver = "1.0";
            }//版本好默认为1.0
            let key = urlParams.key, ver = urlParams.ver;
            delete urlParams.key;
            delete urlParams.ver;
            if (XMLHttpRequest && localStorage) { //判断是否存在 XMLHttpRequest 和 localStorage 对象
                try {
                    var cont = localStorage.getItem(key);
                    cont = JSON.parse(cont); //读取本地存储中的东西
                    if (cont && cont.ver == ver) { //读取版本号，如果版本好相同，则从缓存中读取内容
                        var jsFn = new Function(cont.content);
                        return { url: _url, callback: jsFn };
                    }
                    var xhr = new XMLHttpRequest(); //得到xmlhttpRequest
                    if (xhr.upload) { //判断是否支持2.0
                        let callback = { sn: null, en: null };
                        xhr.timeout = 10000;//js 10秒超时
                        //如果加载成功
                        xhr.onload = function () {
                            localStorage.setItem(key, JSON.stringify({
                                url: url,
                                content: xhr.responseText,
                                ver: ver
                            }))
                            var jsFn = new Function(xhr.responseText);
                            jsFn.call(window);
                            callback.sn && callback.sn();
                        };
                        xhr.ontimeout = function () {
                            //超时
                            callback.en && callback.en();
                        };
                        xhr.onerror = function () {
                            //错误处理
                            callback.en && callback.en();
                        }
                        callback.load = function () {
                            // get脚本
                            xhr.open('GET', _url, true);
                            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;");
                            xhr.send("");
                        }
                        let domainUrl = _url.substr(0, _url.indexOf("?"));
                        //重新生成地址
                        _url = domainUrl + objectParseToString(urlParams);
                        return { url: _url, callback: callback };
                    }
                } catch (e) {
                }
            }
        }
    }
    return { url: _url, callback: null };
}
function JsLoader(url, success, fail, timeout, max, delay) {
    let urlCache = cacheUrl(url);
    url = urlCache.url;
    var count = 0,
        delayID = 0,
        s,
        head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
    var timeout = timeout || 5000;
    var maxCount = max || 1;
    var timeDelay = delay || 1000;
    var time = Date.now();
    function destroy() { //清除
        clearTimeout(delayID);
        if (s && s.parentNode) {
            head.removeChild(s);
            s.onload = s.onreadystatechange = null;
            s.onload = null;
            s.onerror = null;
            s = undefined;
        }
    }
    function jsSuccess() { //js加载成功
        destroy();
        for (var i = 0; i < LoaderCache[url].su.length; i++) {
            var su = LoaderCache[url].su[i];
            su && su(); //所有缓存都回调一遍
        }
        LoaderCache[url].er.length = 0; //清除错误列表
        LoaderCache[url].su.length = 0; //清除成功列表
        LoaderCache[url].load = true; //url加载成功
    }
    function jsError() { //js加载失败处理
        destroy();
        for (var i = 0; i < LoaderCache[url].er.length; i++) {
            var fn = LoaderCache[url].er[i];
            fn && fn.call(this, null, { responseTime: Date.now() - time, retryCount: count });
        }
        LoaderCache[url].er.length = 0;
        LoaderCache[url].su.length = 0;
    }
    function errorHandler() { //错误处理
        destroy(); //清除
        if (count >= maxCount) {
            jsError();
        } else {
            setTimeout(load, timeDelay);
        }
    }
    function load() {
        destroy();
        count++;
        s = document.createElement('script');
        s.setAttribute('type', 'text/javascript');
        s.setAttribute('src', url);
        s.setAttribute('charset', "utf-8");
        if (s.readyState) {  //IE
            s.onreadystatechange = function () {
                if (s.readyState == "loaded" ||
                    s.readyState == "complete") {
                    jsSuccess()
                }
            };
        } else {
            s.onload = function () {
                jsSuccess()
            };
        }
        head.insertBefore(s, head.firstChild);
        delayID = setTimeout(errorHandler, timeout);
    };
    // 
    if (!LoaderCache.hasOwnProperty(url)) {
        LoaderCache[url] = {
            su: [success],
            er: [fail],
            load: false
        }
    } else {
        if (LoaderCache[url].load) {
            success && success();
        } else {
            LoaderCache[url].su.push(success);
            LoaderCache[url].er.push(fail);
        }
        return;
    }
    if (urlCache.callback != null) {
        if (typeof urlCache.callback == "function") {
            urlCache.callback.call(window);
            jsSuccess();
        } else if (typeof urlCache.callback == "object") {
            urlCache.callback.sn = jsSuccess;
            urlCache.callback.en = load;
            //缓存加载
            urlCache.callback.load();
        } else {
            load();
        }
    } else {
        load();
    }
}
module.exports = JsLoader;